<template>
  <div v-if="menusPlan" class="panel inline">
    <div class="panel-header">
      <p>Menus Plan: <b>{{menusPlan.name}}</b></p>
    </div>
    <div class="panel-body">
      <div class="sides">
        <div class="main">
          <div class="full-scroller in-panel">
            <app-form :fields="fields" :data="menusPlan" :meta="{locales: allLocales, plans: allPlans}" @update="onUpdate" />
          </div>
        </div>
        <div class="side">
          <div class="full-scroller in-panel">
            <div class="box">
              <div class="diagonal-wrap">
                <button class="large-button" @click="onSubmit">{{ menusPlan.id?'Update Menus Plan':'Create Menus Plan' }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import menusPlanFields from "@/lib/form-fields/menusPlan";
import AppForm from "@/components/ui/AppForm";
import {actionIf, delayedIfLoading} from "@/lib/Async";

export default {

  components: { AppForm },

  data() {
    return {
      fields : menusPlanFields,
      menusPlan : null,
      locales : null,
      settingLocale : null
    }
  },

  name: "MenusPlan",
  computed: {
    ...mapGetters(['isLoggedIn', 'allMenusPlans', 'allLocales','allPlans','savedMenusPlan']),

  },

  async mounted() {
    await delayedIfLoading(!this.isLoggedIn, this.initData, this.setLoading, () => this.isLoggedIn, () => this.$router.push('/'))
  },

  methods: {
    ...mapActions(['getMenusPlans', 'getLocales','getPlans', 'setLoading','setSuccess','setError','updateMenusPlan','createMenusPlan']),

    async onSubmit() {
      await this.setLoading(true);
      if (this.menusPlan.id) { //update
        await this.updateMenusPlan([this.menusPlan, this.menusPlan.id])
      }
      else { // create new
        await this.createMenusPlan(this.menusPlan);
        if (this.savedMenusPlan.id) {
          await this.$router.push('/plan-menus-plans/'+this.savedMenusPlan.id)
          await this.initData()
          this.menusPlan = {...this.savedMenusPlan }
        }
      }
      await this.setLoading(false);
    },

    onUpdate(values) {
      this.menusPlan = {...this.menusPlan, ...values};
    },

    async initData() {
      await actionIf([
        [!this.allMenusPlans.length, this.getMenusPlans],
      ])

      this.menusPlan = !isNaN(this.$route.params.id*1) ? this.allMenusPlans.find(it => it.id === this.$route.params.id*1) :
          { name: "" }
    },
  },


}
</script>
